import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { dm_loai_lien_he } from '../../../models/response/category/dm_loai_lien_he';
import { eDmLoaiLienHeActionTypeIds, IDmLoaiLienHeActionTypes } from '../../action-types/crm-category/IDmLoaiLienHeActionTypes';
import { actions } from '../../actions/actionsWrapper';

export function* dmLoaiLienHeSaga(): any {
    yield takeLatest(eDmLoaiLienHeActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eDmLoaiLienHeActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eDmLoaiLienHeActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: IDmLoaiLienHeActionTypes): any {
    const dm_coso_id: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.crmCategoryWrapper.loaiLienHe.select_by_coso, dm_coso_id)
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.loaiLienHe.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.crmCategoryWrapper.loaiLienHe.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: IDmLoaiLienHeActionTypes): any {
    const payload: dm_loai_lien_he = action.payload as dm_loai_lien_he;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.crmCategoryWrapper.loaiLienHe.update, payload)
    } else {
        res = yield call(apiWrapper.crmCategoryWrapper.loaiLienHe.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.loaiLienHe.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.crmCategoryWrapper.loaiLienHe.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IDmLoaiLienHeActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.crmCategoryWrapper.loaiLienHe.delete, payload)
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.loaiLienHe.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.crmCategoryWrapper.loaiLienHe.DELETE_ERROR(res.message ?? "Error"))
    }
}
